import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import {FileText, Quote} from "lucide-react";
import {find, xor} from 'lodash';
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {color, font, radius, type} from "common/tokens";

const useStyles = makeStyles({
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  header: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 8,
  },
  label: {
    ...type.meta,
    color: color.TEXT,
    margin: 0,
  },
  clear: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_SUBTLE,
    appearance: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  options: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  option: {
    ...type.chip,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    borderRadius: radius.PILL,
    border: `1px solid ${color.CARD_BORDER}`,
    background: color.SURFACE,
    color: color.TEXT_MUTED,
    padding: '7px 14px',
    cursor: 'pointer',
  },
  selected: {
    borderColor: 'transparent',
    background: color.ACCENT,
    color: color.ON_ACCENT,
  },
});

const TypeOfPostFilter = ({setFeedFilter, filterValue}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const [postTypeFilters, setPostTypeFilters] = useState([...filterValue]);

  useEffect(() => {
    setFeedFilter("event", postTypeFilters);
  }, [postTypeFilters]);

  const addType = type => setPostTypeFilters(xor(postTypeFilters, [type]));
  const isSelected = type => Boolean(find(postTypeFilters, i => i === type));

  const options = [
    {key: 'Post', label: t('posts'), icon: <FileText size={14}/>},
    {key: 'Quotes', label: t('quotes'), icon: <Quote size={14}/>},
  ];

  return (
    <div className={classes.group}>
      <div className={classes.header}>
        <p className={classes.label}>{t('typeOfPost')}</p>
        <button type={'button'} className={classes.clear} onClick={() => setPostTypeFilters([])}>
          {t('clear')}
        </button>
      </div>
      <div className={classes.options}>
        {options.map(option => (
          <button
            key={option.key}
            type={'button'}
            className={classNames(classes.option, isSelected(option.key) && classes.selected)}
            onClick={() => addType(option.key)}
          >
            {option.icon}
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TypeOfPostFilter;
